"use client";
import { PageType, POIType } from "@/types";
import { useAuth } from "./AuthProvider";
import Login from "./Login";
import { MutableRefObject, useState } from "react";

import { TransformControls } from "three/examples/jsm/Addons.js";
import { removeIds } from "./AdminUtils";

import styles from "@/adminArea/admin.module.scss";
import { Vector3 } from "three";
import { useAnimationFrame } from "framer-motion";

import { AdminAnimationPlayer } from "./AdminAnimationPlayer";

export default function AdminContent({
	page,
	animatedCameraRef,
	selected_admin_POI,
	selectPOI,
	adminTransformRef,
	modelRef,
}: {
	page: PageType;
	animatedCameraRef: MutableRefObject<any>;
	selected_admin_POI: POIType | null;
	selectPOI: (poi: POIType | null) => void;
	adminTransformRef: MutableRefObject<TransformControls>;
	modelRef: MutableRefObject<any>;
}) {
	const { isAuthenticated, updatePage } = useAuth();
	const [open, setOpen] = useState<boolean>(false);
	const [controlSettings, setControlSettings] = useState({
		horizontal: 0,
		vertical: 0,
		distance: 0,
		target: new Vector3(),
		camera: new Vector3(),
	});

	const extractXYZ = (obj: { x: number; y: number; z: number; [key: string]: any }) => {
		const { x, y, z } = obj;
		return { x, y, z };
	};

	const SaveCamera = async () => {
		// console.log(page);
		const currentPosTarget = animatedCameraRef.current?.getCameraAndTarget();

		// console.log(page.documentId, extractXYZ(currentPosTarget.camera));

		try {
			const updateResponse = await updatePage(page.documentId, {
				default_camera_position: extractXYZ(currentPosTarget.camera),
				default_camera_target: extractXYZ(currentPosTarget.target),
			});

			// router.reload();
			// window.location.reload();
			console.log("updateResponse ", updateResponse);
		} catch (e) {
			console.log("e from AdminContent", e);
		}
	};

	const savePOI = async () => {
		if (!selected_admin_POI) {
			return;
		}
		let pois = [...page.pois];

		const currentPosTarget = animatedCameraRef.current?.getCameraAndTarget();

		pois = pois.map((p) => {
			if (p.id === selected_admin_POI.id) {
				p.position = extractXYZ(adminTransformRef.current.object.position.clone());
				p.camera_position = extractXYZ(currentPosTarget.camera);
				p.target = extractXYZ(currentPosTarget.target);
			}

			return removeIds(p) as POIType;
		});

		try {
			const updateResponse = await updatePage(page.documentId, {
				pois: pois,
			});
			console.log("updateResponse ", updateResponse);
			window.location.reload();
		} catch (e) {
			console.log(e);
		}
	};

	const addPOI = async () => {
		console.log();
		let pois = [...page.pois] as Partial<POIType>[];
		const currentPosTarget = animatedCameraRef.current?.getCameraAndTarget();
		pois.push({
			title: "Neuer POI",
			content: null,
			position: { x: 0, y: 0, z: 0 },
			camera_position: extractXYZ(currentPosTarget.camera),
			target: extractXYZ(currentPosTarget.target),
		});

		pois = pois.map((p) => removeIds(p));

		try {
			const updateResponse = await updatePage(page.documentId, {
				pois: pois as POIType[],
			});
			console.log("updateResponse ", updateResponse);
			window.location.reload();
		} catch (e) {
			console.log(e);
		}
	};

	const removePOI = async (poi: POIType) => {
		let pois = [...page.pois] as Partial<POIType>[];
		pois = pois.filter((p) => p.id !== poi.id);
		pois = pois.map((p) => removeIds(p));
		try {
			const updateResponse = await updatePage(page.documentId, {
				pois: pois as POIType[],
			});
			console.log("updateResponse ", updateResponse);
			window.location.reload();
		} catch (e) {
			console.log(e);
		}
	};

	useAnimationFrame(() => {
		const controls = animatedCameraRef.current ? animatedCameraRef.current.getControls() : null;

		if (controls) {
			const azimuthAngle = controls.getAzimuthalAngle();
			const polarAngle = controls.getPolarAngle();
			const distance = controls.getDistance();
			const currentPosTarget = animatedCameraRef.current?.getCameraAndTarget();

			setControlSettings({
				vertical: polarAngle,
				horizontal: azimuthAngle,
				distance: distance,
				target: currentPosTarget.target,
				camera: currentPosTarget.camera,
			});
		}
	});

	return (
		<div>
			<button onClick={() => setOpen(!open)}>{open ? "Schließen" : "Admin öffnen"}</button>
			{!isAuthenticated && open && <Login />}
			{isAuthenticated && open && (
				<div className={styles.panel}>
					<div className={styles.component}>
						{animatedCameraRef.current ? (
							<>
								<table>
									<tbody>
										<tr>
											<td>
												<strong>Vertical</strong>
											</td>
											<td>{((controlSettings.vertical * 180) / Math.PI).toFixed(0)}</td>
										</tr>
										<tr>
											<td>
												<strong>Horizontal</strong>
											</td>
											<td>{((controlSettings.horizontal * 180) / Math.PI).toFixed(0)}</td>
										</tr>
										<tr>
											<td>
												<strong>Distance</strong>
											</td>
											<td>{controlSettings.distance.toFixed(2)}</td>
										</tr>
										<tr>
											<td>
												<strong>Camera</strong>
											</td>
											<td>
												x {controlSettings.camera.x.toFixed(1)} <br />y {controlSettings.camera.y.toFixed(1)} <br />z {controlSettings.camera.z.toFixed(1)}
											</td>
										</tr>
										<tr>
											<td>
												<strong>Target</strong>
											</td>
											<td>
												x {controlSettings.camera.x.toFixed(1)} <br />y {controlSettings.camera.y.toFixed(1)} <br />z {controlSettings.camera.z.toFixed(1)}
											</td>
										</tr>
									</tbody>
								</table>
							</>
						) : null}

						<button onClick={() => SaveCamera()}>Save Camera Position</button>
					</div>

					<div className={styles.component}>
						{page.pois.map((poi: POIType) => {
							return (
								<div key={poi.id} className={`flex margin-bottom ${selected_admin_POI?.id === poi.id ? styles.selectedPOI : ""}`}>
									<button key={poi.id} className={styles.adminPOI} onClick={() => (selected_admin_POI?.id === poi.id ? selectPOI(null) : selectPOI(poi))}>
										{poi.title}
									</button>
									<button className={styles.removePOI} onClick={() => removePOI(poi)}>
										x
									</button>
								</div>
							);
						})}
					</div>

					<div className={styles.component}>
						<button className={styles.submit} onClick={() => addPOI()}>
							POI hinzufügen
						</button>
					</div>
					<div className={styles.component}>
						<div className="flex flex-between">
							<button className={styles.cancel} onClick={() => selectPOI(null)}>
								Cancel
							</button>
							<button className={styles.submit} onClick={() => savePOI()}>
								Save POI Position & Target
							</button>
						</div>
					</div>

					<AdminAnimationPlayer modelRef={modelRef} />
				</div>
			)}
		</div>
	);
}
